import { compile } from 'path-to-regexp';
export const generatePath = (pattern = '/', params) => pattern === '/' ? pattern : compile(pattern)(params);